import React, { useContext } from "react";
import "./Intro.css";
import dentists from "../../img/aiec2.png";
import tooth from "../../img/crown.png";
import thumbup from "../../img/thumbup.png";
import FloatinDiv from "../FloatingDiv/FloatingDiv";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";
import { Link } from "react-scroll";
const Intro = () => {
  // Transition
  const transition = { duration: 2.5, type: "spring" };

  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="Intro" id="Intro">
      {/* left name side */}
      <div className="i-left">
        <div className="i-name">
          {/* yahan change hy darkmode ka */}
          <span style={{ color: darkMode ? "white" : "" }}>Top-rated engineering consultancy</span>
          <span>Sur, Sultanate of Oman</span>
          <span>
          As a client-intimate consulting firm, we go beyond traditional design. With deep knowledge of our client’s requirements, we offer tailor-made solutions for each project. We do not pursue one-time transactions; we cultivate relationships.
          </span>
        </div>
        {/*<Link to="contact" smooth={true} spy={true}>*/}
        <a href="tel:+96892130617">
          <button className="button i-button">Schedule a meeting</button>
          </a>
       {/*</Link>*/}
        {/* consulting hours */}
        <div className="i-consult">
          <span>OFFICE HOURS</span>
        </div>
        <div className="i-consultdetails">
          <span>8:30AM - 1:00PM & 4:30PM - 8:30PM</span>
        </div>
        <div className="i-consultnotes">
          <span>*Till 1:00PM only on Thursdays</span>
        </div>
        <div className="i-consultnotes2">
          <span>*Fridays will be closed</span>
        </div>
      </div>
      {/* right image side */}
      <div className="i-right">
        <img src={dentists} alt="" />
        {/* animation */}
        <motion.img
          initial={{ left: "-36%" }}
          whileInView={{ left: "-24%" }}
          transition={transition}
          src={""}
          alt=""
        />

        <motion.div
          initial={{ top: "-4%", left: "74%" }}
          whileInView={{ left: "68%" }}
          transition={transition}
          className="floating-div"
        >
          <FloatinDiv img={tooth} text1="Extensive" text2="Experience" />
        </motion.div>

        {/* animation */}
        <motion.div
          initial={{ left: "9rem", top: "18rem" }}
          whileInView={{ left: "0rem" }}
          transition={transition}
          className="floating-div"
        >
          {/* floatinDiv mein change hy dark mode ka */}
          <FloatinDiv img={thumbup} text1="Expert" text2="Team" />
        </motion.div>

        <div className="blur" style={{ background: "rgb(17, 18, 184);" }}></div>
        <div
          className="blur"
          style={{
            background: "#b3b9e9",
            top: "17rem",
            width: "21rem",
            height: "11rem",
            left: "-19rem",
          }}
        ></div>
      </div>
    </div>
  );
};

export default Intro;
